import { gql } from '@apollo/client';

export const getCarts = gql`
  query GetCarts($filter: CartFilter, $pagination: Pagination) {
    count: getCartsLength(filter: $filter)
    rows: getCarts(filter: $filter, pagination: $pagination) {
      delivery_id
      id
      customer_id
      supplier_id
      customer_address_id
      user_id
      order_total
      security_deposit_paid
      security_deposit
      delivery_amount
      customer_paid
      cart_number
      payment_status
      discount
      free_delivery
      payment_id
      payment_type
      tracking_code
      delivery_instructions
      source
      country
      createdAt
      updatedAt
      # payment {
      #   amount
      #   reference
      #   status
      # }
      reseller {
        id
        email
        name
        country
        phone
        verified
        first_order_created
        user_type
        username
        google_id
        deviceToken
        facebook_id
        twitter_id
        supplier_shop_id
      }
      supplier {
        id
        name
        email
        phone
        country
        has_verified_phonenumber
        has_verified_email
        setup_complete
        generic_name
        device_token
        agreement_terms
        social_platform
        social_platform_token
        createdAt
        deletedAt
      }
      orderItems {
        id
        orderNumber
        quantity
        profitAdded
        status
        supplier_status
        source
        price
        sku
        order_id
        createdAt
        updatedAt
        product {
          sku
          id
          title
          limited_stock
          qty
          instantDelivery
          main_stock
          minimumOrderQuantity
          distributionChannels
          transit_stock
          price
          profit_added
          currency
          country
          description
          extra_information
          combination_string
          published
          inhouse
          attended_to
          verified
          cost_price
          weight
          avatar
          tags
          shop_id
          resell
          uuid
          likesCount
          savesCount
          sharesCount
          supplier_id
          created_at
          overalReview
        }
      }
      customer {
        id
        name
        email
        phone
      }
      delivery {
        id
        location
        price
        country
        remarks
        isPayOnline
      }
    }
  }
`;

export const getCart = gql`
  query GetCart($filter: CartFilter) {
    getCart(filter: $filter) {
      delivery_id
      id
      customer_id
      supplier_id
      customer_address_id
      user_id
      order_total
      security_deposit_paid
      security_deposit
      delivery_amount
      customer_paid
      cart_number
      payment_status
      discount
      free_delivery
      payment_id
      payment_type
      delivery_type
      tracking_code
      delivery_instructions
      source
      country
      createdAt
      updatedAt
      orderItems {
        id
        orderNumber
        quantity
        profitAdded
        status
        supplier_status
        source
        price
        sku
        order_id
        createdAt
        updatedAt
        product {
          sku
          id
          title
          limited_stock
          qty
          main_stock
          minimumOrderQuantity
          distributionChannels
          transit_stock
          price
          profit_added
          currency
          country
          description
          extra_information
          combination_string
          published
          inhouse
          attended_to
          verified
          cost_price
          weight
          avatar
          tags
          shop_id
          resell
          uuid
          likesCount
          savesCount
          sharesCount
          supplier_id
          created_at
          instantDelivery
          overalReview
        }
      }
      delivery {
        id
        location
        price
        country
        remarks
        isPayOnline
      }
      customer {
        id
        name
        email
        phone
      }
      reseller {
        id
        email
        name
        country
        phone
        verified
        first_order_created
        user_type
        username
        google_id
        deviceToken
        facebook_id
        twitter_id
        supplier_shop_id
      }
      address {
        country
        city
        area
        landmark
        lat
        lng
        id
      }
      # payment {
      #   id
      #   reference
      #   status
      #   message
      #   phone
      #   email
      #   amount
      #   currency
      #   cart
      #   fullname
      #   paidAt
      #   network
      #   createdAt
      #   updatedAt
      #   psp
      #   reasonForPayment
      # }
    }
  }
`;

export const getPickUpLocations = gql`
  query GetPickUpLocations($filter: DeliveryFilter, $pagination: Pagination) {
    getPickUpLocations(filter: $filter, pagination: $pagination) {
      id
      location
      country
      google_location
      longitude
      latitude
      remarks
    }
  }
`;

export const getOrders = gql`
  query GetOrderItem($filter: OrderFilter, $pagination: Pagination) {
    count: getOrdersLength(filter: $filter)
    rows: getOrders(filter: $filter, pagination: $pagination) {
      id
      orderNumber
      quantity
      profitAdded
      status
      supplier_status
      source
      price
      sku
      order_id
      createdAt
      updatedAt
      product {
        id
        title
        sku
        avatar
        price
        cost_price
        currency
        country
        combination_string
        qty
        weight
        description
        tags
        published
        verified
      }
      order {
        id
        cart_number
        payment_status
        payment_type
        order_total
        customer_paid
        delivery_amount
        discount
        tracking_code
        source
        country
        createdAt
        customer {
          id
          name
          email
          phone
        }
        reseller {
          id
          name
          email
          username
        }
        delivery {
          id
          location
          price
          country
        }
      }
    }
  }
`;

export const getOrderItem = gql`
  query GetOrder($filter: OrderFilter) {
    getOrder(filter: $filter) {
      id
      orderNumber
      quantity
      status
      supplier_status
      history {
        id
        status
        ops_personel
        created_at
        updated_at
      }
      comments {
        id
        message
        title
        staff_name
        createdAt
        updatedAt
      }
      sku
      order_id
      order {
        id
        customer_id
        supplier_id
        coupon_id
        customer_address_id
        user_id
        user_type
        delivery_amount
        shipping_cost
        delivery_id
        cart_number
        payment_status
        discount
        free_delivery
        payment_id
        payment_type
        instantDelivery
        delivery_type
        tracking_code
        delivery_instructions
        source
        country
        createdAt
        updatedAt
        payment {
          id
          wallet_id
          reference
          amount
          currency {
            code
            name
          }
          direction
          type
          status
          metadata
          created_at
          updated_at
        }
        reseller {
          id
          name
          country
          state
          verified
          username
        }
        customer {
          id
          name
        }
        address {
          country
          city
          area
          landmark
          lat
          lng
          id
        }
        delivery {
          id
          location
          country
          remarks
          isPayOnline
          hasInstantDelivery
          instantDeliveryPrice
        }
      }
      createdAt
      updatedAt
      product {
        id
        title
        sku
        main_stock
        instantDelivery
        minimumOrderQuantity
        maximumDeliveryTime
        minimumDeliveryTime
        shippingCost
        distributionChannels
        transit_stock
        supplier_cost
        currency
        country
        description
        extra_information
        combination_string
        published
        cost_price
        weight
        avatar
        categories {
          id
          name
          type
          description
          isActive
          avatar
        }
        media {
          id
          avatar
          product_id
        }
        shop_id
        likesCount
        savesCount
        digitalDetails
        sharesCount
        supplier_id
        created_at
        updated_at
        status
        overalReview
        reviews {
          id
          rating
          comment
          user_id
        }
        reviewBreakDown {
          totalReviews
          breakDown {
            poor
            average
            good
            veryGood
            excellent
          }
        }
      }
    }
  }
`;
